import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, change, changeType, icon, description, trend }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-soft hover:shadow-elevated transition-smooth">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-2">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={icon} size={20} className="text-primary" />
            </div>
            <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
          </div>
          
          <div className="space-y-2">
            <p className="text-2xl font-bold text-foreground">{value}</p>
            
            {change && (
              <div className="flex items-center space-x-2">
                <div className={`flex items-center space-x-1 ${getChangeColor()}`}>
                  <Icon name={getChangeIcon()} size={14} />
                  <span className="text-sm font-medium">{change}</span>
                </div>
                <span className="text-xs text-muted-foreground">vs last month</span>
              </div>
            )}
            
            {description && (
              <p className="text-xs text-muted-foreground">{description}</p>
            )}
          </div>
        </div>
        
        {trend && (
          <div className="w-16 h-12 ml-4">
            <div className="w-full h-full bg-muted/50 rounded flex items-end justify-center space-x-1">
              {trend?.map((value, index) => (
                <div
                  key={index}
                  className={`w-2 rounded-t ${
                    value > 50 ? 'bg-success' : value > 25 ? 'bg-warning' : 'bg-muted'
                  }`}
                  style={{ height: `${Math.max(value, 10)}%` }}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricsCard;